import { Flex, themedColor } from '@lemonade-hq/cdk';
import type React from 'react';
import styled, { useTheme } from 'styled-components';

const Circle = styled(Flex)`
  width: 120px;
  height: 120px;
  background-color: ${themedColor('cloud')};
  border-radius: 100%;
  align-items: center;
  justify-content: center;
`;

export const LockSvg: React.FC = () => {
  const {
    colors: { paleGray, night, alto, white, glass },
  } = useTheme();

  return (
    <Circle>
      <svg fill="none" height="70" viewBox="0 0 53 70" width="53" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.7384 28.4335C11.2535 28.4182 9.25089 26.3908 9.26616 23.9059L9.30211 18.055C9.35912 8.77618 16.7764 1.27161 25.8362 1.32728C34.895 1.38295 42.2185 8.97809 42.1615 18.2569L42.1289 23.5558C42.1137 26.0418 40.0873 28.0434 37.6014 28.0281C35.1164 28.0128 33.1138 25.9865 33.1291 23.5005L33.1617 18.2016C33.1882 13.8847 29.8768 10.3523 25.7809 10.3271C21.683 10.3019 18.3285 13.7934 18.3019 18.1103L18.266 23.9612C18.2507 26.4461 16.2234 28.4487 13.7384 28.4335Z"
          fill={paleGray}
        />
        <path
          d="M13.7384 28.4335C11.2535 28.4182 9.25089 26.3908 9.26616 23.9059L9.30211 18.055C9.35912 8.77618 16.7764 1.27161 25.8362 1.32728C34.895 1.38295 42.2185 8.97809 42.1615 18.2569L42.1289 23.5558C42.1137 26.0418 40.0873 28.0434 37.6014 28.0281C35.1164 28.0128 33.1138 25.9865 33.1291 23.5005L33.1617 18.2016C33.1882 13.8847 29.8768 10.3523 25.7809 10.3271C21.683 10.3019 18.3285 13.7934 18.3019 18.1103L18.266 23.9612C18.2507 26.4461 16.2234 28.4487 13.7384 28.4335Z"
          stroke={night}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M51.5046 32.4216C51.2526 28.188 48.2848 24.5727 42.9088 24.3926C42.9088 24.3926 13.6113 23.8876 10.4223 24.374C5.02407 25.2068 2.60525 27.937 2.11884 32.5581C1.66704 36.9184 1.67275 51.9378 1.92969 57.9695C2.27398 65.8977 8.07611 68.3354 14.1698 68.7319L39.9051 69.087C46.6066 68.8662 50.8127 65.281 51.3282 61.1331C52.1009 54.9927 51.9483 39.9575 51.5046 32.4216Z"
          fill={alto}
        />
        <path
          d="M18.3168 24.1585C14.7535 24.1856 11.8294 26.7987 11.6289 30.1315C11.2645 36.2244 10.8322 45.3899 11.2817 49.3797C12.1807 57.3434 10.7625 67.4669 19.3062 67.8624C28.9168 67.6435 39.5204 68.0516 44.0965 67.9007C47.3822 67.7899 50.865 64.7393 50.917 61.6505L50.6622 28.5733C50.6622 28.5733 48.6309 24.0668 43.615 24.0359C40.1671 24.0148 26.5043 24.0948 18.3169 24.1425L18.3168 24.1585Z"
          fill={white}
        />
        <path
          d="M36.7084 39.0858C35.7654 37.294 33.8359 36.0701 31.5799 36.0562C28.401 36.0367 25.797 38.4737 25.7784 41.4867C25.7661 43.4996 26.9213 45.2628 28.6255 46.2123L28.5944 51.2682L28.5942 51.2982L28.594 51.3292L28.5935 51.4192C28.6605 52.8736 29.8943 54.0462 31.4543 54.0558C33.0133 54.0654 34.2614 52.908 34.3464 51.4545L34.3467 51.3945L34.3471 51.3335L34.3475 51.2735L34.3784 46.2326C35.8825 45.4088 36.9813 43.9776 37.2338 42.2831"
          fill={glass}
        />
        <path
          d="M34.5929 36.8778C33.7201 36.3624 32.6899 36.063 31.5799 36.0562C28.401 36.0367 25.797 38.4737 25.7784 41.4857C25.7661 43.4996 26.9203 45.2628 28.6255 46.2113L28.5944 51.2682L28.5942 51.2982L28.594 51.3282L28.5935 51.4192C28.6605 52.8736 29.8943 54.0462 31.4533 54.0558C33.0123 54.0654 34.2624 52.908 34.3474 51.4545L34.3477 51.3945L34.3481 51.3335L34.3485 51.2735L34.3794 46.2316C35.8825 45.4088 36.9804 43.9766 37.2338 42.2831"
          stroke={night}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M36.7084 39.0858C36.655 38.9845 36.5986 38.8841 36.5382 38.7868"
          stroke={night}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M13.8068 64.4946C13.3219 63.6706 13.0335 62.7608 12.9243 61.8191C12.3379 56.1854 11.9434 38.0246 12.4099 31.1134C12.4999 29.8129 12.8506 28.566 13.4462 27.4917"
          stroke={night}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M29.6026 23.7288C21.5314 23.5793 12.3609 23.7879 9.42221 24.3849C4.87744 25.309 2.60513 27.956 2.11973 32.5771C1.66793 36.9374 1.66541 53.2957 1.92245 59.3114C2.26575 67.2387 8.0771 68.3374 14.1697 68.7509C20.949 69.2005 33.6296 68.8214 40.4292 68.5852C47.2288 68.349 49.8126 65.2928 50.3451 61.145C51.1178 55.0056 50.9684 39.4464 50.5247 31.9096C50.2728 27.6759 47.2665 24.9454 41.9257 24.4056C39.5491 24.166 36.4473 23.9689 33.1269 23.8495"
          stroke={night}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </svg>
    </Circle>
  );
};
